export default "__VITE_ASSET__5b9bdf35__"